/*
 * Public API Surface of empty-state
 */

export * from './empty-state.component';
export * from './empty-state.module';
